<template lang="">
  <div>
    <v-dialog v-model="dialog" width="620px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-toolbar-title class="text-uppercase">THÊM {{ $route.meta.title }}</v-toolbar-title>
          <v-spacer />
          <v-icon color="white" @click="cancel">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <headFeeNewForm ref="form" />
        <v-divider></v-divider>
        <v-card-actions class="mt-5">
          <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel"
            >Hủy</v-btn
          >
          <v-spacer />
          <v-btn
            depressed
            class="px-6 mr-4 mt-n4 mb-2 white--text"
            :loading="loading"
            :disabled="loading"
            color="primary"
            @click="save"
          >
            Lưu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import headFeeNewForm from '../../../components/basic/form/headFeeNewForm.vue'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    headFeeNewForm
  },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      loading: false,
      isBtnSave: false
    }
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee'])
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['createHeadFees']),
    cancel() {
      this.reset()
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
    async save() {
      this.loading = true
      const data = this.$refs.form.getData()
      if (data) {
        this.isBtnSave = true
        await this.createHeadFees(data)
        this.reset()
        this.$emit('addHeadFeeSuccess')
        this.dialog = false
        this.isBtnSave = false
      }
      this.loading = false
    }
  },
  watch: {
    state() {
      this.dialog = true
    }
  }
}
</script>
<style lang=""></style>
